export const SHARED_QUERY_KEYS = {
  BILLING_INFO: 'billingInfo',
  USER_PROFILE: 'userProfile',
} as const;
